"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var coupon_items_1 = require("../coupon-items");
/**
 * 运营代金券组件双卡的底部推荐部分
 */
function Suggest(props) {
    var subTitle = props.subTitle, describe = props.describe, link = props.link;
    return (react_1.default.createElement("div", { className: "om-bottom" },
        react_1.default.createElement("div", { className: "om-sub-title" }, subTitle),
        react_1.default.createElement("div", { className: "om-describe" },
            describe,
            (link === null || link === void 0 ? void 0 : link.text) && react_1.default.createElement(coupon_items_1.Link, { text: link.text, to: link.to, extendProps: link.extendProps }))));
}
exports.default = Suggest;
//# sourceMappingURL=Suggest.js.map